<div class="row" style="margin: 1rem; align-items: center; display: flex;">

  <div class="col-2" style="display: flex; align-items: center;">
    <img src="assets/img/LOGO_GG  color - 2000.png" alt="Logo" style="height:80px; margin-top: -0.7rem;">
  </div>

  <div class="col-8" style="display: flex; justify-content: center; align-items: center;">
    <div
      style="font-weight: 300; font-family: 'Segoe UI', Tahoma, sans-serif; color: #adadad; margin: 0; font-size: 2.9rem;">
      Pagina di caricamento documentazione
    </div>
  </div>

  <div class="col-2"></div>
</div>



<div class="main-content" style="height: calc(100vh - 20px); padding-top:0; margin-bottom:0; margin-top: 3rem"
  *ngIf="item">
  <div class="row" style="height: 100%;  margin-bottom:0">
    <div class=" col-md-12" style="height: 100%; margin-bottom:0">

      <form [formGroup]="form" (keydown.enter)="$event.preventDefault()" style="height: 100%; ">
        <div class="card" style="height: 100%; ">
          <div class="card-header card-header-info">
            <h4 class="card-title">Perizia - ID: {{item.id ? item.id : 'NUOVO'}}

              <div style="float:right">



              </div>
            </h4>
          </div>
          <div class="card-body" style="width: 100%!important; height: 100%" *ngIf="loading">
            <div class="row">
              <div class="col-sm-2" style="margin:auto">

                <mat-spinner *ngIf="isMSIE()"></mat-spinner>
                <mat-progress-spinner mode="indeterminate" [value]="loading_percentage" *ngIf="!isMSIE()">
                </mat-progress-spinner>

              </div>
            </div>

          </div>
          <div class="card-body" style="width: 100%!important; height: 100%;" [hidden]="loading">

            <div class="row">

              <div class="col-sm-4">

                <mat-form-field class="full">
                  <mat-label>Targa</mat-label>
                  <input type="text" matInput placeholder="Targa" formControlName="targa" [(ngModel)]="item.targa"
                    [readonly]="true">
                </mat-form-field>



              </div>


              <div class="col-sm-4">
                <mat-form-field class="full">
                  <mat-label>Telaio</mat-label>
                  <input type="text" matInput placeholder="Telaio" formControlName="telaio" [(ngModel)]="item.telaio"
                    [readonly]="true">
                </mat-form-field>
              </div>

              <div class="col">
                <mat-form-field class="full">
                  <mat-label>Stato</mat-label>


                  <input type="text" matInput [(ngModel)]="item.stato" formControlName="stato" readonly>

                </mat-form-field>
              </div>

              <div class="col" *ngIf="(db.getIcon()=='gg' || db.getIcon()=='test' )  && item?.cliente==1">
                <mat-form-field class="full">
                  <mat-label>Stato Est.</mat-label>

                  <mat-select placeholder="Stato Est." [(ngModel)]="item.stato1" formControlName="stato1"
                    *ngIf="permission?.permitStatusChange">
                    <mat-option *ngFor="let i of stati1" [value]="i">
                      {{i}}
                    </mat-option>
                  </mat-select>

                  <input type="text" matInput *ngIf="!permission?.permitStatusChange" [(ngModel)]="item.stato1"
                    formControlName="stato1" readonly>

                </mat-form-field>
              </div>

            </div>

            <div class="row" style="margin-top: 1rem;">
              <div class="col-sm-4">
                <mat-form-field class="full">
                  <mat-label>Rif Aziendale (nome e cognome)*</mat-label>
                  <input type="text" matInput placeholder="Nome e Cognome" formControlName="patrocinatore_nome"
                    [(ngModel)]="item.patrocinatore_nome">
                </mat-form-field>
              </div>

              <div class="col-sm-4">
                <mat-form-field class="full">
                  <mat-label>Email (aziendale)*</mat-label>
                  <input type="email" matInput placeholder="Email aziendale" formControlName="patrocinatore_email"
                    [(ngModel)]="item.patrocinatore_email">
                </mat-form-field>
              </div>

              <div class="col-sm-4">
                <mat-form-field class="full">
                  <mat-label>Tel (aziendale)</mat-label>
                  <input type="tel" matInput placeholder="Telefono aziendale" formControlName="patrocinatore_telefono"
                    [(ngModel)]="item.patrocinatore_telefono">
                </mat-form-field>
              </div>
            </div>



            <mat-tab-group (selectedTabChange)="onLinkClick($event)" [selectedIndex]="+tab"
              [backgroundColor]="'primary'" [color]="'danger'">
              <!--
              <mat-tab label="Dati sinistro" *ngIf="type=='perizie'" [disabled]="!permission?.tabs[1]"
                style="height: 100%" [ngClass]="{'hidden': type!='perizie'}"><br>
                <div class="row">
                  <div class="col-sm-4 card">
                    <div class="card-header card-header-primary">
                      <h5 class="card-title">Sinistro</h5>
                    </div><br>



                    <mat-form-field class="full">
                      <mat-label>Numero sinistro</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Numero sinistro" (ngModelChange)="claimNrChange($event)"
                        formControlName="sinistro_numero" [(ngModel)]="item.sinistro_numero">

                      <i *ngIf="errorClaimNr" class="material-icons" style="float:right; color:red">error</i>

                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Partita di danno</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="number" matInput
                        placeholder="Partita di danno" formControlName="partita_danno" [(ngModel)]="item.partita_danno">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Mandante sinistro</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Mandante sinistro" formControlName="sinistro_mandante"
                        [(ngModel)]="item.sinistro_mandante">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Data sinistro</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="date" matInput
                        placeholder="Data sinistro" formControlName="sinistro_data" [(ngModel)]="item.sinistro_data">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Targa Assicurato</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Targa Assicurato" formControlName="sinistro_targaAssicurato"
                        [(ngModel)]="item.sinistro_targaAssicurato">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Nome Assicurato</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Nome Assicurato" formControlName="sinistro_nomeAssicurato"
                        [(ngModel)]="item.sinistro_nomeAssicurato">
                    </mat-form-field>

                  </div>



                  <div class="col-sm-4 card">
                    <div class="card-header card-header-info">
                      <h5 class="card-title">Danneggiato</h5>
                    </div><br>

                    <mat-form-field class="full">
                      <mat-label>Nominativo</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Nominativo" formControlName="danneggiato_nome" [(ngModel)]="item.danneggiato_nome">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Provincia</mat-label>
                      <mat-select [disabled]="permission?.tabs[1] == 2 || !permission?.permitted"
                        placeholder="Provincia" [(ngModel)]="item.danneggiato_provincia"
                        formControlName="danneggiato_provincia"
                        (ngModelChange)="selectProvinciaDanneggiatoChange($event)">
                        <mat-option *ngFor="let i of province" [value]="i.sigla">
                          {{i.sigla}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Comune</mat-label>
                      <mat-select [disabled]="permission?.tabs[1] == 2 || !permission?.permitted" placeholder="Comune"
                        [(ngModel)]="item.danneggiato_citta" formControlName="danneggiato_citta"
                        (ngModelChange)="selectComuneDanneggiatoChange($event)">
                        <mat-option *ngFor="let i of comuniDanneggiato" [value]="i.nome">
                          {{i.nome}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>CAP</mat-label>
                      <mat-select [disabled]="permission?.tabs[1] == 2 || !permission?.permitted" placeholder="CAP"
                        [(ngModel)]="item.danneggiato_cap" formControlName="danneggiato_cap">
                        <mat-option *ngFor="let i of capDanneggiato" [value]="i">
                          {{i}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Indirizzo</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Indirizzo" formControlName="danneggiato_indirizzo"
                        [(ngModel)]="item.danneggiato_indirizzo">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Telefono</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Telefono" formControlName="danneggiato_telefono"
                        [(ngModel)]="item.danneggiato_telefono">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Fax</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Fax" formControlName="danneggiato_fax" [(ngModel)]="item.danneggiato_fax">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Email</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="email" matInput
                        placeholder="Email" formControlName="danneggiato_email" [(ngModel)]="item.danneggiato_email">
                    </mat-form-field>

                  </div>
                  
                  <div class="col-sm-4 card">
                    <div class="card-header card-header-success">
                      <h5 class="card-title">Patrocinatore</h5>
                    </div><br>

                    <mat-form-field class="full">
                      <mat-label>Nominativo</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Nominativo" formControlName="patrocinatore_nome"
                        [(ngModel)]="item.patrocinatore_nome">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Provincia</mat-label>
                      <mat-select [disabled]="permission?.tabs[1] == 2 || !permission?.permitted"
                        placeholder="Provincia" [(ngModel)]="item.patrocinatore_provincia"
                        formControlName="patrocinatore_provincia"
                        (ngModelChange)="selectProvinciaPatrocinatoreChange($event)">
                        <mat-option *ngFor="let i of province" [value]="i.sigla">
                          {{i.sigla}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Comune</mat-label>
                      <mat-select [disabled]="permission?.tabs[1] == 2 || !permission?.permitted" placeholder="Comune"
                        [(ngModel)]="item.patrocinatore_citta" formControlName="patrocinatore_citta"
                        (ngModelChange)="selectComunePatrocinatoreChange($event)">
                        <mat-option *ngFor="let i of comuniPatrocinatore" [value]="i.nome">
                          {{i.nome}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>CAP</mat-label>
                      <mat-select [disabled]="permission?.tabs[1] == 2 || !permission?.permitted" placeholder="CAP"
                        [(ngModel)]="item.patrocinatore_cap" formControlName="patrocinatore_cap">
                        <mat-option *ngFor="let i of capPatrocinatore" [value]="i">
                          {{i}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Indirizzo</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Indirizzo" formControlName="patrocinatore_indirizzo"
                        [(ngModel)]="item.patrocinatore_indirizzo">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Telefono</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Telefono" formControlName="patrocinatore_telefono"
                        [(ngModel)]="item.patrocinatore_telefono">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Fax</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="text" matInput
                        placeholder="Fax" formControlName="patrocinatore_fax" [(ngModel)]="item.patrocinatore_fax">
                    </mat-form-field>

                    <mat-form-field class="full">
                      <mat-label>Email/PEC</mat-label>
                      <input [readonly]="permission?.tabs[1] == 2 || !permission?.permitted" type="email" matInput
                        placeholder="Email/PEC" formControlName="patrocinatore_email"
                        [(ngModel)]="item.patrocinatore_email">
                    </mat-form-field>
                  </div>
                </div>


              </mat-tab>

              -->



              <mat-tab label="Doc Perizia" *ngIf="item.stato == 'NUOVO INCARICO'">



                <ng-template matTabLabel>
                  <span>Documenti Richiesti</span>
                </ng-template>


                <!--

                <button type="button" mat-fab
                 (click)="toggleAddAdz()">+</button>
                  
                -->
                <div class="row" style="margin-left:0;">

                  <br>

                  <div class="col" style="min-height: 60vh">
                    <div class="card">

                      <div class="row sub-title">
                        <div class="header-title">
                          Cliccare sul pulsante <span class="plus">+</span> per caricare i documenti richiesti
                        </div>
                      </div>

                      <div class="row doc-cards" style="margin: 0.1rem">
                        <div class="col" *ngFor="let e of customTypes">
                          <div class="doc-card" [ngClass]="getNDocByType(e.code) >= e.required ? 'ok' : 'missing'">

                            <div class="doc-header">
                              <h4>
                                <span class="doc-number">{{ getNumber(e.code) }}</span>
                                <span class="doc-text">{{ getText(e.code) }}</span>
                              </h4>
                            </div>

                            <div class="doc-footer">
                              <small>{{ e.required }} documento richiesto</small>
                              <div class="doc-buttons">
                                <button class="btn-icon add" (click)="addDoc(e)">
                                  <i class="material-icons">add</i>
                                </button>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>


                      <div style="margin-top: 1rem;">
                        <app-gallery #gallery (onSelected)="openViewer($event)" (onAdd)="upsertAllegati($event)"
                          [hideGenericUpload]="true" [customDocTypes]="getCustomTypes()" [(source)]="item.allegati"
                          [categorized]="false" [showLabel]="true" accepted="image/jpg,image/jpeg,application/pdf"
                          [downloading]="false" [viewButtons]="false" [isPublicUploader]="true">
                        </app-gallery>
                      </div>

                      <div *ngIf="loading_percentage">
                        <br>
                        <h3 style="text-align: center;">{{ loading_percentage ? ('INSPECTIONS_DIALOG.SAVING_IN_PROGRESS'
                          |
                          translate) : ('INSPECTIONS_DIALOG.LOADING' | translate) }}</h3>
                        <mat-progress-bar *ngIf="loading_percentage > 0" [value]="loading_percentage"
                          [mode]="loading_percentage == 100 ? 'indeterminate' : 'determinate'"> </mat-progress-bar>
                        <h3 style="text-align: center;">

                          {{loading_loaded/1024/1024 | number:'.1-1'}} / {{loading_total/1024/1024 | number:'.1-1'}}MB
                          -
                          {{loading_percentage | number: '.0-0'}}%
                        </h3>
                      </div>

                      <!-- privacy checkbox -->
                      <div class="form-group" style="margin: 1rem 1rem 0 1rem; text-align: left;">
                        <div style="display: flex; align-items: center;">
                          <mat-checkbox formControlName="privacyOk" color="primary">
                            <span style="display: inline-flex; align-items: center;">
                              Ho letto e accetto l'informativa privacy:&nbsp;
                              <a href="https://www.privacylab.it/informativa.php?23958494256" target="_blank"
                                rel="noopener noreferrer" style="font-weight: 500; text-decoration: none;">
                                https://www.privacylab.it/informativa.php?23958494256
                              </a>
                            </span>
                          </mat-checkbox>
                        </div>

                        <div *ngIf="form.controls['privacyOk'].touched && form.controls['privacyOk'].invalid"
                          style="color: red; font-weight: 500; font-size: 0.8rem; margin-left: 0.7rem;">
                          È necessario accettare l'informativa per poter inviare.
                        </div>
                      </div>



                      <button class="btn btn-success" (click)="complete()" type="button" [disabled]="!isCompleted()">
                        COMPLETA E INVIA
                      </button>


                      <div class="mt-2" style="text-align: center;">
                        Per qualsiasi informazione, non esitate a contattarci all'indirizzo
                        <a href="mailto:cpo&#64;general-group.it">cpo&#64;general-group.it</a>
                      </div>

                      <div class="row d-flex justify-content-center">
                        <mat-spinner *ngIf="isLoading" [diameter]="90"></mat-spinner>
                      </div>


                    </div>
                  </div>

                </div>



              </mat-tab>

              <mat-tab label="Doc Perizia" *ngIf="item.stato != 'NUOVO INCARICO'">

                <div class="row" style="height: 30vh; justify-content: center; align-items: center;">
                  <div class="col-md-8">
                    <div class="msg-upload-ok">
                      I documenti caricati sono in attesa di revisione da parte dei nostri operatori
                    </div>
                  </div>
                </div>


              </mat-tab>

            </mat-tab-group>


          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<app-doc-viewer [index]="docviewer_i" [(files)]="docviewer_source" *ngIf="docviewer" (closed)="closeDocviewer()"
  [position]="docviewer_position" [filter]="docviewer_filter" [doubleView]="docviewer_double" [descr]="docviewer_descr">
</app-doc-viewer>


<div class="dialog animated heartBeat" *ngIf="showAddAdz">
  <a style="float:right" (click)="toggleAddAdz()"><i class="material-icons">close</i></a>
  <app-gallery [(source)]="item.allegati" [uploader]="true" id="allegati" [disabled]="!permission?.tabs[5]">
  </app-gallery>
</div>


<div class="dialog-large animated heartBeat" *ngIf="showReclamo">

  <a style="float:right" (click)="toggleReclamo()"><i class="material-icons">close</i></a>

  <app-reclami [id]="item.id"></app-reclami>

</div>